import React from "react";
import { useThemeStore } from "../store/themeStore";
import { isDarkTheme } from "../config/themes";
import "./EvictedScreen.css";

/**
 * Issue #304 — dead-end "session ended" page.
 *
 * Rendered in place of the whole app when `marketdata.closedByServer === true`.
 * No buttons, no spinners, no live code: the connection is permanently gone
 * and the user must reload the page on their own to recover.
 */
const EvictedScreen = () => {
  const theme = useThemeStore((state) => state.theme);
  const isDark = isDarkTheme(theme);

  return (
    <div
      className={`evicted-screen ${isDark ? "dark-theme" : "light-theme"}`}
      data-evo-id="evicted-screen"
      role="alert"
    >
      <div className="evicted-content">
        <div className="evicted-icon">🔌</div>
        <h1>Sessão encerrada</h1>
        <p>Sua conta foi aberta em outro local.</p>
        <p className="evicted-hint">Esta janela não está mais conectada.</p>
      </div>
    </div>
  );
};

export default EvictedScreen;
